<ng-container *ngIf="(isModeSet$ | async)">
    <ng-container *ngTemplateOutlet="(isVenue$ | async) === true ? venue || null : location || null"></ng-container>
</ng-container>